import { render } from "./HomeMarketingStickyBottom.vue?vue&type=template&id=1dc90f39"
import script from "./HomeMarketingStickyBottom.vue?vue&type=script&lang=js"
export * from "./HomeMarketingStickyBottom.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jonathanthomas/Documents/Sites/vuejs/gr2022-phase-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__